module.exports = __webpack_public_path__ + "static/media/Oppaat_sis_hh_2013_SUOMI.bef68a49.png";